<div class="tab-container">
  <h2 class="app">Policy Totals - Price Indication #{{ quoteBreakdown()?.indicationNumber }}</h2>
  <table class="policy-table">
    <tr>
      <td>Rated Premium</td>
      <td class="amount">{{ quoteBreakdown()?.ratedPremium | currency:'USD' }}</td>
    </tr>
    <tr>
      <td>Inspection Fee</td>
      <td class="amount">{{ quoteBreakdown()?.inspectionFee | currency:'USD' }}</td>
    </tr>
    <tr *ngFor="let item of quoteBreakdown()?.additionalProgramFees">
      <td>{{ item.name }}</td>
      <td class="amount">{{ item.amount | currency:'USD' }}</td>
    </tr>
    <tr>
      <td>MGA Fee</td>
      <td class="amount">{{ quoteBreakdown()?.mgaFee | currency:'USD' }}</td>
    </tr>
    <tr *ngFor="let item of quoteBreakdown()?.additionalMGAFees">
      <td>{{ item.name }}</td>
      <td class="amount">{{ item.amount | currency:'USD' }}</td>
    </tr>
    <tr>
      <td>Retail Broker Fee</td>
      <td class="amount">{{ quoteBreakdown()?.retailBrokerFee| currency:'USD' }}</td>
    </tr>
    <tr>
      <td>Surplus Lines Tax</td>
      <td class="amount">{{ quoteBreakdown()?.surplusLinesTax| currency:'USD' }}</td>
    </tr>
    <tr>
      <td>Stamping Office Fee</td>
      <td class="amount">{{ quoteBreakdown()?.stampingFee| currency:'USD' }}</td>
    </tr> 
  </table>

  <div class="w-full flex justify-between mt-2">
    <h3 class="app">Price Indication</h3>
    <h3 class="app">{{ quoteBreakdown()?.total | currency:'USD' }}</h3>
  </div>


  <div *ngIf="authStore.isWholesale() || authStore.isAdmin()" class="mt-[35px]">
    <h2 class="app">Rated Premium Breakdown</h2>
    <table class="policy-table">
      <thead>
        <tr style="height: 50px;">
          <th colspan="4" class="text-left">
            <h4 class="app">Classifications & Premium</h4>
          </th>
          <th colspan="2" style="text-align: left;">Rate</th>
          <th colspan="2" style="text-align: center;">Advance Premium</th>
          <th colspan="1"></th>
        </tr>
        <tr class="mt-3 table-border-top">
          <th class="text-left">Zip Code</th>
          <th class="text-left">Classification</th>
          <th class="text-left">Code No</th>
          <th class="text-left">Premium Base</th>
          <th class="text-left">Prem/Ops</th>
          <th class="text-left">Prod/Comp Ops</th>
          <th class="text-left">Prem/Ops</th>
          <th class="text-left">Prod/Comp Ops</th>
          <th class="text-left">Total</th>
        </tr>
      </thead>
      <tbody>
        <tbody>
          <tr *ngFor="let item of viewSubmissionStore.premiumBreakdown?.()?.classPremiumBreakDown">
            <td>{{ item.zipcode }}</td>
            <td>{{ item.className }}</td>
            <td>{{ item.classCode }}</td>
            <td>{{ item.premiumBase | currency:'USD' }}</td>
            <td>{{ item.premOpsRate | currency:'USD' }}</td>
            <td>{{ item.prodOpsRate | currency:'USD' }}</td>
            <td>{{ item.premOpsPremium | currency:'USD' }}</td>
            <td>{{ item.prodOpsPremium | currency:'USD' }}</td>
            <td>{{ item.total | currency:'USD' }}</td>
          </tr>
          <tr>
            <td></td>
            <td colspan="2">Minimum Premium Adjustment</td>
            <td colspan="5"></td>
            <td>{{ viewSubmissionStore.premiumBreakdown?.()?.minimumPremiumAdjustment | currency:'USD' }}</td>
          </tr>
          <tr>
            <td></td>
            <td colspan="2">Endorsement Premium</td>
            <td colspan="5"></td>
            <td>{{ viewSubmissionStore.premiumBreakdown?.()?.endorsementPremium | currency:'USD' }}</td>
          </tr>
      
      </tbody>
    </table>

    <div *ngIf="authStore.isAdmin() && quoteBreakdown()?.optionalForms?.length! > 0" class="mt-[35px]">
      <table class="policy-table">
        <colgroup>
          <col style="width: 85%;">
          <col style="width: 7.5%;">
          <col style="width: 7.5%;">
        </colgroup>
        <tr class="table-border-bottom" style="height: 50px;">
          <th colspan="3" class="text-left">
            <h4 class="app">Optional Forms</h4>
          </th>
        </tr>
        <tr *ngFor="let item of quoteBreakdown()?.optionalForms">
          <td>{{ item.title }}</td>
          <td>{{ item.debitPercent ? ("+" + item.debitPercent + "%") : ""}}</td>
          <td class="amount">{{ (item.price ?? item.premium ?? "0.00") | currency:'USD' }}</td>
        </tr>
      </table>
    </div>

    <div class="mt-[35px]">
      <table class="policy-table">
        <colgroup>
          <col style="width: 85%;">
          <col style="width: 7.5%;">
          <col style="width: 7.5%;">
        </colgroup>
        <tr class="table-border-bottom" style="height: 50px;">
          <th colspan="3" class="text-left">
            <h4 class="app">Discounts & Credits</h4>
          </th>
        </tr>
        <tr>
          <td>Schedule Credit Applied</td>
          <td>{{ viewSubmissionStore.premiumBreakdown?.()?.scheduleCredit ? ("+" + viewSubmissionStore.premiumBreakdown?.()?.scheduleCredit) : "+0.0"}}</td>
          <td class="amount">{{ viewSubmissionStore.premiumBreakdown?.()?.scheduleCreditDiscount }}</td>
        </tr>
      </table> 
    </div>


    <div class="w-full flex mt-5">
      <div class="w-1/2">
        <h3>Total Rated Premium</h3>
      </div>
      <div class="w-1/2 text-right">
        <h3>{{ viewSubmissionStore.premiumBreakdown?.()?.totalRatedPremium | currency:'USD' }}</h3>
      </div>
    </div>
  
  </div>
</div>